import { useState, useRef } from "react";
import { DashboardTopBar, PageHead } from "shared";
import "./ContactPage.scss";
import { Button, DropFileInput, SelectComponent, Textarea } from "shared";
import * as Yup from "yup";
import useSendContactAsUserMessage from "hooks/contact/SendContactMessageAsUserHook";
import { VALIDATION_ENUM } from "enums";
import { Field, Form, Formik } from "formik";

const ContactPage = () => {
  const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);
  const { mutateAsync: sendMessage } = useSendContactAsUserMessage();
  const formRef = useRef<any>(null);
  const onSubmit = (values: any) => {
    sendMessage(values, {
      onSuccess: () => {
        formRef.current.resetForm();
        setIsSubmitSuccess(true);
      },
    });
  };

  const initialValues = {
    topic: "",
    message: "",
    file: null,
  };

  const validation = () =>
    Yup.object().shape({
      topic: Yup.string().required(VALIDATION_ENUM.REQUIRED),
      message: Yup.string().required(VALIDATION_ENUM.REQUIRED),
    });

  return (
    <>
      <PageHead
        title="Kontakt i pomoc techniczna | App Reliance Pro"
        description="Masz pytania? Skontaktuj się z naszym zespołem. Pomagamy w obsłudze aplikacji i rozwiązujemy techniczne trudności."
      />
      <div className="contact">
        <DashboardTopBar>
          <h1 className="dashboard__header">Kontakt i wsparcie</h1>
        </DashboardTopBar>
        <div className="dashboard-content__wrapper">
          <div className="dashboard-content">
            <div className="contact__wrapper">
              {isSubmitSuccess ? (
                <div className="profile__success-message">
                  <h3 className="profile__menu-subheader">
                    Dziękujemy za kontakt! Twoja wiadomość została wysłana.
                    Odpowiemy na nią tak szybko, jak to możliwe.
                  </h3>
                  <Button
                    size="large"
                    styleType="primary"
                    label="Wyślij kolejną wiadomość"
                    onClick={() => setIsSubmitSuccess(false)}
                  />
                </div>
              ) : (
                <>
                  <h3 className="contact__subheader">
                    Potrzebujesz pomocy lub masz pytania? Jesteśmy tu, aby Cię
                    wesprzeć. Wybierz temat, opisz swoją sprawę i załącz plik,
                    jeśli to potrzebne — odpowiemy tak szybko, jak to możliwe.
                  </h3>

                  <Formik
                    initialValues={initialValues}
                    onSubmit={(values: any) => onSubmit(values)}
                    validationSchema={validation()}
                    enableReinitialize
                    innerRef={formRef}
                  >
                    {({ errors, values, handleSubmit, setFieldValue }) => {
                      return (
                        <Form onSubmit={handleSubmit}>
                          <Field
                            label="Temat"
                            name="topic"
                            id="topic"
                            placeholder="Wybierz "
                            as={SelectComponent}
                            options={[
                              {
                                label:
                                  "Pełnomocnictwo na walne zgromadzenie spółki, w której jestem akcjonariuszem",
                                value:
                                  "Pełnomocnictwo na walne zgromadzenie spółki, w której jestem akcjonariuszem",
                              },
                              {
                                label: "Problemy techniczne",
                                value: "Problemy techniczne",
                              },
                              {
                                label: "Inny powód",
                                value: "Inny powód",
                              },
                            ]}
                          />
                          <Field
                            label={"Załącz plik"}
                            name="file"
                            id="file"
                            as={DropFileInput}
                            accept=".pdf,.doc,.docx,.jpg,.png"
                            optional
                          />
                          <p className="contact__file-info">
                            Dopuszczalne formaty plików: pdf, jpg, png, doc,
                            docx.
                          </p>
                          <Field
                            type="textarea"
                            id="message"
                            name="message"
                            label={"Treść wiadomości"}
                            component={Textarea}
                            errors={errors}
                            maxLength={1000}
                            placeholder="Wpisz swoją wiadomość..."
                          />
                          <div className="contact__buttons">
                            <Button
                              size="large"
                              styleType="primary"
                              label="Wyślij"
                              type="submit"
                              onClick={() => {}}
                            />
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
